"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SvgComponent(props) {
  var fill = props.fill,
      size = props.size;
  return React.createElement("svg", {
    style: {
      margin: 'auto',
      background: '0 0'
    },
    width: size,
    height: size,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    display: "block"
  }, React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(45 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(90 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(135 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(180 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(225 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(270 50 50)"
  }), React.createElement("rect", {
    x: 46,
    y: 6,
    rx: 4,
    ry: 5.76,
    width: 8,
    height: 24,
    fill: fill,
    transform: "rotate(315 50 50)"
  }));
}

SvgComponent.defaultProps = {
  fill: '#333',
  size: 14
};
var _default = SvgComponent;
exports.default = _default;